export default __webpack_public_path__ + "static/media/2.779a07f7.png";